export var countryKey = 'Country';
export var PaymentFormFieldType = /*#__PURE__*/function (PaymentFormFieldType) {
  PaymentFormFieldType["FIELD"] = "paymentFields";
  PaymentFormFieldType["COUNTRY_LIST"] = "countryList";
  PaymentFormFieldType["ERROR"] = "paymentErrors";
  PaymentFormFieldType["SERVER_ERROR"] = "serverErrors";
  return PaymentFormFieldType;
}({});
export var PaymentFormDataFields = /*#__PURE__*/function (PaymentFormDataFields) {
  PaymentFormDataFields["ALL_REQUIRED_FIELDS"] = "AllRequiredFields";
  PaymentFormDataFields["UPI_ALL_REQUIRED_FIELDS"] = "upiAllFieldsAreRequired";
  PaymentFormDataFields["PAY_WITH_CARD"] = "PayWithCard";
  PaymentFormDataFields["EDIT_CARD"] = "EditCard";
  PaymentFormDataFields["NAME_ON_THE_CARD"] = "NameOnCard";
  PaymentFormDataFields["CARDHOLDER_NAME"] = "CardName";
  PaymentFormDataFields["CARD_NAME"] = "CardName";
  PaymentFormDataFields["CARD_NUMBER"] = "CardNumber";
  PaymentFormDataFields["EXPIRATION"] = "ExpDate";
  PaymentFormDataFields["EXPIRATION_MONTH"] = "ExpMonth";
  PaymentFormDataFields["EXPIRATION_YEAR"] = "ExpYear";
  PaymentFormDataFields["EXPIRATION_ERROR"] = "ExpirationDate";
  PaymentFormDataFields["CVV"] = "Cvv";
  PaymentFormDataFields["EXP"] = "Exp";
  PaymentFormDataFields["ZIP_POSTAL"] = "ZipPostal";
  PaymentFormDataFields["COUNTRY"] = "Country";
  PaymentFormDataFields["UPI_COUNTRY"] = "upiCountry";
  PaymentFormDataFields["CITY"] = "City";
  PaymentFormDataFields["COUNTRY_PLACEHOLDER"] = "SearchCountry";
  PaymentFormDataFields["FIND_YOUR_CVV"] = "FindYourCvv";
  PaymentFormDataFields["CVV_SUBHEADING_VISA"] = "CvvSubheadingVisa";
  PaymentFormDataFields["CVV_SUBHEADING_AMEX"] = "CvvSubheadingAmex";
  PaymentFormDataFields["FOUR_DIGIT_CODE"] = "FourDigitSecurityCode";
  PaymentFormDataFields["VISA_CARD_ALT_TEXT"] = "VisaCardAltText";
  PaymentFormDataFields["AMEX_CARD_ALT_TEXT"] = "AmexCardAltText";
  PaymentFormDataFields["THREE_DIGIT_CODE"] = "ThreeDigitSecurityCode";
  PaymentFormDataFields["PAY_WITH_UPI"] = "payWithUpi";
  PaymentFormDataFields["NAME"] = "Name";
  PaymentFormDataFields["PINCODE"] = "pinCode";
  PaymentFormDataFields["PAY_WITH_UPI_CARD"] = "payWithUpiCard";
  PaymentFormDataFields["EXP_DATE_MMYYYY"] = "expDateMMYYYY";
  PaymentFormDataFields["UPDATE"] = "update";
  PaymentFormDataFields["OBFUSCATED_CC"] = "ObfuscatedCC";
  PaymentFormDataFields["EXPIRED"] = "Expired";
  PaymentFormDataFields["GIFTCARD_VALUE"] = "GiftCardValue";
  PaymentFormDataFields["GIFTCARD_ZERO_BALANCE"] = "GiftCardZeroBalance";
  PaymentFormDataFields["GIFTCARD_INSUFFICIENT_BALANCE"] = "GiftCardInsufficientBalance";
  PaymentFormDataFields["GIFTCARD_SUFFICIENT_BALANCE"] = "GiftCardSufficientBalance";
  PaymentFormDataFields["VERIFY_ADDRESS"] = "VerifyAddress";
  PaymentFormDataFields["ADD_HIDDEN_HEADER"] = "AddHiddenHeader";
  PaymentFormDataFields["DEFAULT_HIDDEN_HEADER"] = "DefaultHiddenHeader";
  PaymentFormDataFields["LIST_HIDDEN_HEADER"] = "ListHiddenHeader";
  PaymentFormDataFields["EDIT_HIDDEN_HEADER"] = "EditHiddenHeader";
  PaymentFormDataFields["FETCH_INVALID_ZIP"] = "FetchInvalidZip";
  PaymentFormDataFields["EDIT"] = "edit";
  PaymentFormDataFields["ADD_PAYMENT_METHOD"] = "addPaymentMethod";
  PaymentFormDataFields["ADD_VENMO"] = "AddVenmo";
  PaymentFormDataFields["CANCEL"] = "cancel";
  PaymentFormDataFields["UPDATE_CARD"] = "updateCard";
  PaymentFormDataFields["ADD_CARD"] = "addCard";
  PaymentFormDataFields["PAYMENT_METHOD"] = "paymentMethod";
  PaymentFormDataFields["OR"] = "or";
  PaymentFormDataFields["REQUIRED_CARD_NAME"] = "Name on card is required.";
  PaymentFormDataFields["REQUIRED_CARD_NUMBER"] = "Card number is required.";
  PaymentFormDataFields["REQUIRED_EXPIRATION_DATE"] = "Expiration date is required.";
  PaymentFormDataFields["REQUIRED_ZIP_POSTAL"] = "Zip/Postal Code is required.";
  PaymentFormDataFields["REQUIRED_CVV"] = "CVV is required.";
  PaymentFormDataFields["INVALID_CARD_NAME"] = "Only letters and special characters: `'~.- can be used.";
  PaymentFormDataFields["INVALID_CARD_NUMBER"] = "Card number is invalid.";
  PaymentFormDataFields["INVALID_EXPIRATION_DATE"] = "Expiration date is invalid.";
  PaymentFormDataFields["INVALID_ZIP_POSTAL"] = "Zip/Postal Code is invalid.";
  PaymentFormDataFields["INVALID_CVV"] = "CVV is invalid.";
  PaymentFormDataFields["INVALID_COUNTRY"] = "Country is invalid.";
  PaymentFormDataFields["INVALID_PINCODE"] = "PIN code must be exactly 6 numbers.";
  PaymentFormDataFields["REQUIRED_CITY"] = "You must select a city.";
  PaymentFormDataFields["REQUIRED_PINCODE"] = "PIN code must be exactly 6 numbers.";
  PaymentFormDataFields["PRIMARY_PAYMENT_METHOD"] = "PrimaryPaymentMethod";
  PaymentFormDataFields["BACKUP_PAYMENT_METHOD"] = "BackupPaymentMethod";
  PaymentFormDataFields["MAKE_DEFAULT_CHECKBOX_LABEL"] = "MakeThisDefault";
  PaymentFormDataFields["MAKE_BACKUP_CHECKBOX_LABEL"] = "MakeThisBackup";
  PaymentFormDataFields["EXP_WITH_DATE"] = "ExpWithDate";
  PaymentFormDataFields["LAST_FOUR"] = "LastFour";
  PaymentFormDataFields["CARD_ENDING_IN"] = "CardEndingIn";
  return PaymentFormDataFields;
}({});
export var PaymentFormValidationFields = /*#__PURE__*/function (PaymentFormValidationFields) {
  PaymentFormValidationFields["REQUIRED_CARD_NAME"] = "RequiredCardName";
  PaymentFormValidationFields["REQUIRED_CARD_NUMBER"] = "RequiredCardNumber";
  PaymentFormValidationFields["REQUIRED_EXPIRATION_DATE"] = "RequiredExpirationDate";
  PaymentFormValidationFields["REQUIRED_ZIP_POSTAL"] = "RequiredZipPostal";
  PaymentFormValidationFields["REQUIRED_CVV"] = "RequiredCvv";
  PaymentFormValidationFields["REQUIRED_PINCODE"] = "RequiredPinCode";
  PaymentFormValidationFields["INVALID_CARD_NAME"] = "InvalidCardName";
  PaymentFormValidationFields["INVALID_CARD_NUMBER"] = "InvalidCardNumber";
  PaymentFormValidationFields["INVALID_EXPIRATION_DATE"] = "InvalidExpirationDate";
  PaymentFormValidationFields["INVALID_ZIP_POSTAL"] = "InvalidZipPostal";
  PaymentFormValidationFields["INVALID_CVV"] = "InvalidCvv";
  PaymentFormValidationFields["INVALID_COUNTRY"] = "InvalidCountry";
  PaymentFormValidationFields["REQUIRED_CITY"] = "RequiredCity";
  PaymentFormValidationFields["INVALID_NAME"] = "InvalidName";
  PaymentFormValidationFields["INVALID_PINCODE"] = "InvalidPinCode";
  return PaymentFormValidationFields;
}({});
export var REQUIRED_ERRORS = new Set([PaymentFormDataFields.REQUIRED_CARD_NAME, PaymentFormDataFields.REQUIRED_CARD_NUMBER, PaymentFormDataFields.REQUIRED_EXPIRATION_DATE, PaymentFormDataFields.REQUIRED_ZIP_POSTAL, PaymentFormDataFields.REQUIRED_CVV, PaymentFormDataFields.REQUIRED_CITY, PaymentFormDataFields.REQUIRED_PINCODE]);
export var INVALID_ERRORS = new Set([PaymentFormDataFields.INVALID_CARD_NAME, PaymentFormDataFields.INVALID_CARD_NUMBER, PaymentFormDataFields.INVALID_EXPIRATION_DATE, PaymentFormDataFields.INVALID_ZIP_POSTAL, PaymentFormDataFields.INVALID_CVV, PaymentFormDataFields.INVALID_COUNTRY, PaymentFormDataFields.INVALID_PINCODE]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/constants.js
// module id = 70
// module chunks = 11